import { ref, uploadString, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebaseConfig';

// Upload a base64 image to Firebase Storage
export const uploadImage = async (base64Image: string, path: string): Promise<string> => {
  // Remove the data URL prefix (e.g., "data:image/jpeg;base64,")
  const base64Content = base64Image.split(',')[1];

  // Create a storage reference
  const storageRef = ref(storage, path);

  // Upload the image
  await uploadString(storageRef, base64Content, 'base64');

  // Get the download URL
  const downloadURL = await getDownloadURL(storageRef);

  return downloadURL;
};

// Upload a base64 document to Firebase Storage
export const uploadDocument = async (base64Document: string, path: string): Promise<string> => {
  // Remove the data URL prefix
  const base64Content = base64Document.split(',')[1];

  // Create a storage reference
  const storageRef = ref(storage, path);

  // Upload the document
  await uploadString(storageRef, base64Content, 'base64');

  // Get the download URL
  const downloadURL = await getDownloadURL(storageRef);

  return downloadURL;
};

// Delete a file from Firebase Storage
export const deleteFile = async (path: string): Promise<void> => {
  const storageRef = ref(storage, path);
  await deleteObject(storageRef);
};

// Generate a unique file path for dog photos
export const generateDogPhotoPath = (dogId: string, fileName: string): string => {
  // Extract extension from fileName or from the data URL if available
  let extension = 'jpg';
  if (fileName.includes('.')) {
    extension = fileName.split('.').pop() || 'jpg';
  } else if (fileName.startsWith('data:image/')) {
    const mimeType = fileName.split(';')[0].split(':')[1];
    extension = mimeType.split('/')[1];
  }
  return `dogs/${dogId}/photo_${extension}`;
};

// Generate a unique file path for certification documents
export const generateCertificationPath = (dogId: string, fileName: string): string => {
  // Extract extension from fileName or from the data URL if available
  let extension = 'pdf';
  if (fileName.includes('.')) {
    extension = fileName.split('.').pop() || 'pdf';
  } else if (fileName.startsWith('data:')) {
    const mimeType = fileName.split(';')[0].split(':')[1];
    if (mimeType === 'application/pdf') {
      extension = 'pdf';
    } else if (mimeType.startsWith('image/')) {
      extension = mimeType.split('/')[1];
    }
  }
  return `dogs/${dogId}/certification_${extension}`;
};
